import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { BrandingProvider } from "./components/Branding";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <BrandingProvider>
        <App/>
      </BrandingProvider>
    </BrowserRouter>
  </React.StrictMode>
);
